import { useEffect } from 'react';

const BASE = '每日新料';

export default function usePageMeta(title?: string, description?: string) {
  useEffect(() => {
    if (title) {
      document.title = `${title} - ${BASE}`;
    } else {
      document.title = `${BASE} - 手机参数曝光 · 未发布产品图 · 配置价格预测`;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
}